import { NgModule, Component, OnInit, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { finalize } from 'rxjs/operators';
import { ProductImageApi, LoopBackConfig } from '../../../../assets/js/lb-sdk';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {
  host:string = LoopBackConfig.getPath();
  product;
  productImage;
  error: string;
  loading: boolean = false;
  productImageLink;

  constructor(
    public modal: BsModalRef,
    private productImageApi: ProductImageApi
  ) { }

  formatLink(productImage) {    
    this.productImage = productImage;
    const host = this.host;
    const product = this.product;
    
    this.productImageLink = `${host}/api/ProductImages/link/${product.productType.name}/${product.planTypeCode}`;
    if (this.productImage.name.startsWith('assets/img')) {
      this.productImageLink = this.productImage.name;
    }

  }

  ngOnInit() {
    this.loading = true;
    this.error = undefined;
    this.productImageApi
      .findOne({
        where: {
          planType: this.product.planTypeCode,
          productType: this.product.productType.name
        }
      })
      .pipe(finalize(
        () => {
          this.loading = false;
        })
      )
      .subscribe(this.formatLink,
        error => {
          if (error.statusCode === 404) {
            return this.error = 'No Product setup found for ' + this.product.productType.description + ' '  + this.product.planType;
          }
          this.error = error.message || 'Unable to get product details.';
        }
      );
  }

  dismiss(reason: string) {
    this.modal.content.reason = reason;
    this.modal.hide();
  }

  close(reason: string) {
    this.modal.content.result = reason;
    this.modal.hide();
  }
}
